import { getRootElement } from '@/config/root';

/**
 * @type {[string, string]}
 */
const defaultPeakState = ['60%', '40%'];

/**
 * @param {number} estimatedCardHeight
 * @returns {[string, string]}
 */
export function createPeakPanelState(estimatedCardHeight) {
  const root = getRootElement();
  const rootRect = root?.getBoundingClientRect();
  if (!rootRect.height) {
    return defaultPeakState;
  }

  const persistentFooterHeight = document.getElementById('persistentFooter')?.getBoundingClientRect()?.height ?? 0;
  const availHeight = window.screen.availHeight - rootRect.top - persistentFooterHeight;

  // Look for a peak state that would show up to ~1.5 cards while leaving at least 20 percent to the map;
  // this ignores the height of the drawer handle, which is dynamic.
  const minMapPercent = 20;
  for (let cardsPeaking = 1.5; cardsPeaking >= 1; cardsPeaking -= 0.1) {
    const peakHeight = estimatedCardHeight * cardsPeaking;
    const mapPercent = Math.round((100 * (availHeight - peakHeight)) / rootRect.height);
    if (mapPercent >= minMapPercent) {
      return [`${mapPercent}%`, `${100 - mapPercent}%`];
    }
  }

  return defaultPeakState;
}
